import { computed, ref } from 'vue';
import type { ResultsCompany } from '@/components/widget/results/results-view.types';
import type { CotizaTodasResponse } from '@/types/quote.types';
import { maintainExpandMode } from './expandMode';
import { pickQuotesForEmission, pickSelectedQuotes, pickSummaryCompany, type QuoteCandidates } from './selection';
import type { QuoteSources } from './types';

export function useCompanySelection(sources: QuoteSources) {
  const selectedCompany = ref<ResultsCompany>('QUALITAS');
  const isChubbSelected = computed(() => selectedCompany.value === 'CHUBB');
  const canShareOrDownload = computed(() => !isChubbSelected.value);

  const candidates = (): QuoteCandidates => ({
    qualitas: sources.quotesResponse.value,
    ana: sources.anaQuotes.value,
    chubb: sources.chubbQuotes.value,
  });

  const selectedQuotes = computed<CotizaTodasResponse | null>(() =>
    pickSelectedQuotes(selectedCompany.value, candidates())
  );
  const selectedSummaryCompany = computed<ResultsCompany>(() =>
    pickSummaryCompany(selectedCompany.value, candidates())
  );
  const selectedQuotesForEmission = computed<CotizaTodasResponse | null>(() =>
    pickQuotesForEmission(selectedCompany.value, candidates())
  );

  const handleSelectCompany = (company: ResultsCompany): void => {
    selectedCompany.value = company;
    maintainExpandMode();
  };

  return {
    selectedCompany,
    isChubbSelected,
    canShareOrDownload,
    selectedQuotes,
    selectedSummaryCompany,
    selectedQuotesForEmission,
    handleSelectCompany,
  };
}
